/* global Pjax */
var pjax;

var transitionEnded;

document.addEventListener("pjax:send", function() {
    console.log("Event: pjax:send", arguments);
    jQuery('header').addClass('headroom--loading');
    jQuery('.loading-mask, main').removeClass('completed');
    jQuery('.fancy-popout').removeClass('active').removeClass('finished');
    jQuery('.popout-content').removeClass('active');
    jQuery('.submenu').removeClass('active');
    jQuery('main').unbind('click');
    jQuery('.mobile-menu-container').removeClass('mobile-menu-container--show');

    jQuery('.blocks-wrapper, footer').addClass('transition-out').removeClass('transition-in-end');

    if(menu === 'open'){
      jQuery('.blocks-wrapper, footer').addClass('transition-out-instant');
    }

    /* Check when transition has ended for page transitions */
    transitionEnded = new Promise(function (resolve, reject) {
       document.querySelector('.blocks-wrapper').addEventListener('transitionend', function resolveTransition(event) {
          /* event.propertyName passes the name of the transitioned event. Make sure the longest is passed */
          /* if (event.propertyName !== 'longest transition') return; */

          document.querySelector('.blocks-wrapper').removeEventListener('transitionend', resolveTransition);
          resolve('done');

       });
    });

    /* function defined in header atom */
    if(jQuery('header').hasClass('headroom--menu-open')){
        closeMenu();
        jQuery('header.headroom').removeClass('headroom--menu-open');
    }
});

document.addEventListener("pjax:complete", function() {
    console.log("Event: pjax:complete", arguments);

    jQuery('.loading-mask').addClass('completed');

    jQuery('main').addClass('completed');
    setTimeout(function(){
       jQuery('header').removeClass('headroom--loading');
    }, 200);

    jQuery('header').removeClass('headroom--unpinned');
    jQuery('header').addClass('headroom--pinned');

    if (jQuery('.blocks-wrapper .block:nth-of-type(1)').attr('class').indexOf("hero-image") >= 0){
        jQuery('header').removeClass('headroom--black');
    }
    else{
        jQuery('header').addClass('headroom--black');
    }

    if(jQuery('nav.desktop').is(":visible")){
        var href = jQuery('nav.desktop li.current-menu-item a').attr('href');
        if (href != window.location) {
            jQuery('nav.desktop li.current-menu-item').removeClass('current-menu-item');
            jQuery('nav.desktop li').each(function(){
                href = jQuery(this).find('a').attr('href');
                if(href == window.location){
                    jQuery(this).addClass('current-menu-item');
                }
            })
        }
    }

    checkHeaderCta();
    imageCarousel();
    videoPopup();
    intakeBlocksOnComplete();
    videoGalleryOnComplete();

});

document.addEventListener("pjax:error", function() {
    console.log("Event: pjax:error", arguments)
})

document.addEventListener("pjax:success", function() {
    console.log("Event: pjax:success", arguments);
})

document.addEventListener("DOMContentLoaded", function() {

    jQuery('main, .loading-mask').addClass('completed');

    pjax = new Pjax({
        elements: 'a:not(.no-pjax):not([target="_blank"])',
        selectors: ["head title", ".blocks-wrapper"],
        switches: {
           "head title": Pjax.switches.replaceNode,
           ".blocks-wrapper": function (oldEl, newEl, pjaxOptions) {

              var $this = this;
              var $oldEl = oldEl;
              var $newEl = newEl;

              transitionEnded.then(
                 function () {
                   jQuery('.blocks-wrapper, footer').removeClass('transition-out').removeClass('transition-out-instant');
                   jQuery('.blocks-wrapper').addClass('transition-in-start');
                    $oldEl.innerHTML = $newEl.innerHTML;
                    $this.onSwitch();
                    setTimeout(function(){ jQuery('.blocks-wrapper').addClass('transition-in-end'); }, 5);
                 });

           }
        },
        cacheBust: false,
        scrollRestoration: true,
    });

    if (jQuery('.blocks-wrapper .block:nth-of-type(1)').attr('class').indexOf("hero-image") >= 0){
        jQuery('header').removeClass('headroom--black');
    }
    else{
        jQuery('header').addClass('headroom--black');
    }

    jQuery('.popup-container-close').click(function () {
        if (jQuery(this).hasClass('active')) {
            jQuery('.popup-container').html('').removeClass('active');
            jQuery('.popup-container-close').removeClass('active').css('display', 'none');
            jQuery('.dark-page-overlay').removeClass('active').removeClass('video');
            enableScroll();
        }
    });

    checkHeaderCta();
    videoPopup();
    imageCarousel();
    intakeBlocksOnInit();
    videoGalleryOnInit();
    header(pjax);
});

function checkHeaderCta(){
    if (window.location.href.indexOf("intake/") > -1) {
        jQuery('header').addClass('is-intake');
    }else{
        jQuery('header').removeClass('is-intake');
    }
}

function videoPopup(){
    jQuery('.video-popup-trigger').click(function () {
        var $this = jQuery(this);
        jQuery('.dark-page-overlay').addClass('active').addClass('video');
        setTimeout(function () {
            jQuery('.popup-container-close').addClass('active').fadeIn('fast');
            jQuery('.popup-container').addClass('active');
            jQuery('.popup-container').html('<iframe src="https://www.youtube.com/embed/' + $this.attr('data-embed') + '"></iframe>');
        }, 450);
        disableScroll();
    });
}
